<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="390"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        dark
        v-on="on"
      >
        Add user
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline">{{title}}</v-card-title>
      <v-card-text>
        <v-col cols="12">
          <v-form
            ref="form"
            v-model="adminvalid"
          >
            <v-text-field
              v-model='adminUser.email'
              :rules="emailRules"
              label="Email Address"
              hint="a verification email with sign up instruction will be sent"
            ></v-text-field>
            <v-text-field
              :rules="nameRules"
              v-model='adminUser.displayName'
              label="Display Name"
            ></v-text-field>
            <v-checkbox
              v-model='adminUser.notify'
              label="Send notify email to user?"
            ></v-checkbox>
          </v-form>
        </v-col>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          color="green darken-1"
          text
          @click="dialog = false"
        >Cancel</v-btn>
        <v-btn
          color="green darken-1"
          :disabled='!adminvalid'
          text
          @click="registerAdmin(),dialog = false"
        >Send</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { postReq } from '../../helper/firestore'
import { mapFields } from 'vuex-map-fields';
export default {
  props: {
    userType: String,
  },
  computed: {
    ...mapFields([
      'user',
      'snackBarshow',
      'snackBarType',
      'snackBarmessage',
    ]),
    title () {
      let title
      this.userType === "admin" ? title = "Add new admin" : title = "Add new patient"
      return title
    },
    endPoint () {
      let endPoint
      this.userType === "admin" ? endPoint = 'api/admin/createAdminUser' : endPoint = 'api/admin/createUser'
      return endPoint
    }
  },
  methods: {
    registerAdmin () {
      postReq(process.env.VUE_APP_ROOT_API_URL + this.endPoint, { idToken: this.user.idToken, user: this.adminUser }, result => {
        this.snackBarType = "success"
        this.snackBarshow = true
        this.snackBarmessage = result.data
        this.adminUser.email = ""
        this.adminUser.displayName = ""
      })
    }
  },
  data () {
    return {
      dialog: false,
      adminvalid: false,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      nameRules: [
        v => !!v || 'Name is required',
      ],
      adminUser: {
        email: '',
        emailVerified: true,
        displayName: '',
        disabled: false,
        notify: true,
      }
    }
  }
}
</script>

<style>
</style>
